import { type TemplateConfig, getImagePositionClass } from '@/mocks/template-config';

interface MainImageSectionProps {
  config: TemplateConfig['mainImage'];
  clientBoxConfig: TemplateConfig['clientBox'];
}

export default function MainImageSection({ config, clientBoxConfig }: MainImageSectionProps) {
  const overlayOpacity = config.overlayIntensity / 100;

  return (
    <div className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
      <img
        src={config.image}
        alt={config.altText}
        className={`w-full h-full object-cover ${getImagePositionClass(config.position)}`}
      />
      <div
        className="absolute inset-0"
        style={{ backgroundColor: `rgba(10, 22, 40, ${overlayOpacity})` }}
      />

      {/* Client Box Overlay */}
      {config.showClientBox && clientBoxConfig.show && (
        <div className="absolute bottom-4 left-4 right-4 md:left-auto md:right-8 md:w-80">
          <div className="bg-brand-card/95 backdrop-blur-sm border border-brand-gold/30 rounded-lg p-4">
            <h3 className="text-brand-gold text-sm font-semibold tracking-wide mb-3">
              {clientBoxConfig.title}
            </h3>
            <div className="space-y-2">
              {clientBoxConfig.showClientName && clientBoxConfig.clientName && (
                <div className="flex justify-between">
                  <span className="text-brand-text-muted text-xs">Cliente:</span>
                  <span className="text-brand-text text-sm">{clientBoxConfig.clientName}</span>
                </div>
              )}
              {clientBoxConfig.showCompany && clientBoxConfig.clientCompany && (
                <div className="flex justify-between">
                  <span className="text-brand-text-muted text-xs">Empresa:</span>
                  <span className="text-brand-text text-sm">{clientBoxConfig.clientCompany}</span>
                </div>
              )}
              {clientBoxConfig.showProposalNumber && clientBoxConfig.proposalNumber && (
                <div className="flex justify-between">
                  <span className="text-brand-text-muted text-xs">Proposta:</span>
                  <span className="text-brand-text text-sm">{clientBoxConfig.proposalNumber}</span>
                </div>
              )}
              {clientBoxConfig.showDate && clientBoxConfig.date && (
                <div className="flex justify-between">
                  <span className="text-brand-text-muted text-xs">Data:</span>
                  <span className="text-brand-text text-sm">{clientBoxConfig.date}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}